export const Enquetes = {
  path: '/enquetes',
  meta: { requiresAuth: true },
  component: () => import('layouts/MainLayout.vue'),
  children: [
    {
      path: '',
      name: 'enquetes',
      component: () => import('pages/enquetes/IndexPage.vue'),
      meta: {
        requiresAuth: true,
        title: 'page.enquetes.name',
        path: '/enquetes',
        condition: 'enquetes',
      },
    },
    {
      path: 'create',
      name: 'enquetes-create',
      component: () => import('pages/enquetes/CreatePage.vue'),
      meta: {
        requiresAuth: true,
        title: 'pageType.create',
        parents: [
          {
            title: 'page.enquetes.name',
            path: '/enquetes',
            condition: 'enquetes',
          },
        ],
      },
    },
    {
      path: ':id',
      name: 'enquetes-id',
      component: () => import('pages/enquetes/id/IndexPage.vue'),
      meta: {
        requiresAuth: true,
        title: ':name',
        parents: [
          {
            title: 'page.enquetes.name',
            path: '/enquetes',
            condition: 'enquete',
          },
        ],
      },
    },
    {
      path: ':id/edit',
      name: 'enquetes-id-edit',
      component: () => import('src/pages/enquetes/id/EditPage.vue'),
      meta: {
        requiresAuth: true,
        title: 'pageType.edit',
        parents: [
          {
            title: 'page.enquetes.name',
            path: '/enquetes',
            condition: 'enquetes',
          },
          {
            title: ':name',
            path: '/enquetes/:id',
          },
        ],
      },
    },
    {
      path: ':id/target-resources',
      name: 'enquetes-id-targetResources',
      component: () =>
        import('src/pages/enquetes/id/targetResources/IndexPage.vue'),
      meta: {
        requiresAuth: true,
        title: ':name',
        parents: [
          {
            title: 'page.enquetes.name',
            path: '/enquetes',
            condition: 'enquete',
          },
        ],
      },
    },
    {
      path: ':id/target-resources/:target_resource_id',
      name: 'enquetes-id-targetResources-target_resource_id',
      component: () =>
        import(
          'src/pages/enquetes/id/targetResources/targetResourceId/IndexPage.vue'
        ),
      meta: {
        requiresAuth: true,
        title: ':name',
        parents: [
          {
            title: 'page.enquetes.name',
            path: '/enquetes',
            condition: 'enquete',
          },
          {
            title: ':enqueteName',
            path: '/enquetes/:id/target-resources',
          },
        ],
      },
    },
    {
      path: ':id/list',
      name: 'enquetes-id-list',
      component: () => import('pages/enquetes/id/ListPage.vue'),
      meta: {
        requiresAuth: true,
        title: '回答一覧',
        parents: [
          {
            title: 'page.enquetes.name',
            path: '/enquetes',
            condition: 'enquete',
          },
          {
            title: ':name',
            path: '/enquetes/:id',
          },
        ],
      },
    },
    {
      path: ':id/summary',
      name: 'enquetes-id-summary',
      component: () => import('pages/enquetes/id/SummaryPage.vue'),
      meta: {
        requiresAuth: true,
        title: '集計ボード',
        parents: [
          {
            title: 'page.enquetes.name',
            path: '/enquetes',
            condition: 'enquete',
          },
          {
            title: ':name',
            path: '/enquetes/:id',
          },
        ],
      },
    },
    {
      path: ':id/tallying',
      name: 'enquetes-id-tallying',
      component: () => import('pages/enquetes/id/TallyingPage.vue'),
      meta: {
        requiresAuth: true,
        title: 'page.enquetes.tallying.name',
        parents: [
          {
            title: 'page.enquetes.name',
            path: '/enquetes',
            condition: 'enquete',
          },
          {
            title: ':name',
            path: '/enquetes/:id',
          },
        ],
      },
    },
  ],
};
